import React, { useRef } from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import colors from "../design/Colors";
import TeamMembers from "../assets/images/team.png";
import Office2 from "../assets/images/office2.png";
import Office from "../assets/images/office.png";
import unit from "../assets/images/unit.svg";
import { SecurityPolicy } from "@/components/SecurityPolicy";
import { TermsOfUse } from "@/components/TermsOfUse";
import { LandingLogos } from "@/components/LandingLogos";
import Footer from "@/components/Footer";
import AppBar from "@/components/AppBar";
import { Button } from "@/components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import picture1 from "@/assets/images/handSigning.png";
import picture2 from "@/assets/images/logoCarousel.png";
import picture3 from "@/assets/images/office.png";
import Autoplay from "embla-carousel-autoplay";

export const LandingPage: React.FC = () => {
  const buttonLabels = [
    { text: "Política de Seguridad" },
    { text: "Política de Calidad" },
    { text: "Compromiso de servicio" },
    { text: "Links" },
  ];

  const images = [
    {
      label: "Hand signing",
      imgPath: picture1,
    },
    {
      label: "Logo of MRM",
      imgPath: picture2,
    },
    {
      label: "Office of MRM",
      imgPath: picture3,
    },
  ];
  const sectionRefs: { [key: string]: React.RefObject<HTMLDivElement> } = {
    serviceCompromise: useRef<HTMLDivElement>(null),
    securityPolicy: useRef<HTMLDivElement>(null),
    qualityPolicy: useRef<HTMLDivElement>(null),
    links: useRef<HTMLDivElement>(null),
  };

  const handleScrollToSection = (section: string) => {
    const targetRef = sectionRefs[section];
    if (targetRef.current) {
      const yOffset = -150;
      const y =
        targetRef.current.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <Box
      sx={{
        width: "100vw",
        overflow: "hidden",
        backgroundColor: "white",
        fontFamily: "Montserrat",
        position: "relative",
        zIndex: 0,
      }}
    >
      <AppBar />
      <Box
        sx={{
          width: "80vw",
          height: "25vw",
          border: `2px solid ${colors.green}`,
          borderRadius: "15px",
          zIndex: -1,
          position: "absolute",
          top: "55rem",
          left: "40rem",
          display: { sm: "none", lg: "flex" },
        }}
      ></Box>
      <Box
        sx={{
          width: "calc(100vw - 4rem)",
          height: { xs: "fit-content", lg: "50rem" },
          margin: "8rem auto 0 auto",
          backgroundColor: colors.deepGreen,
          px: { xs: "1.5rem", md: "4rem" },
          py: "2rem",
          borderRadius: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid
          container
          sx={{
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            display: "flex",
            px: "2rem",
            gap: { xs: "2rem", lg: "0rem" },
          }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "start",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  color: colors.white,
                  fontSize: { xs: "2rem", md: "3rem", lg: "3.5rem" },
                  textAlign: "left",
                }}
                fontWeight={700}
                maxWidth={"25rem"}
                fontFamily={"Montserrat"}
              >
                60 Años de ininterrumpida trayectoria.
              </Typography>
              <Button
                variant="containedWhite"
                style={{
                  marginTop: "2rem",
                  padding: "1.5rem 4rem 1.5rem 4rem",
                  minWidth: "15rem",
                }}
              >
                <Typography fontFamily={"Montserrat"} fontWeight={500}>
                  Ver más
                </Typography>
              </Button>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            lg={6}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Carousel
              plugins={[
                Autoplay({
                  delay: 2500,
                  stopOnInteraction: false,
                }),
              ]}
            >
              <CarouselContent>
                {images.map((item, index) => (
                  <CarouselItem key={index}>
                    <img
                      src={item.imgPath}
                      className="w-full h-auto object-cover"
                      alt={item.imgPath}
                    />
                  </CarouselItem>
                ))}
              </CarouselContent>
            </Carousel>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          justifySelf: { xs: "center", lg: "auto" },
          padding: "2rem 2rem 2rem 2rem",
          backgroundColor: " #4E8468",
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          width: { xs: "calc(100vw - 4rem)", md: "30rem" },
          borderRadius: "24px",
          gap: "2rem",
          position: { xs: "auto", lg: "relative" },
          top: "-8rem",
          left: "7rem",
          my: { xs: "2rem", lg: "auto" },
        }}
      >
        {buttonLabels.map((item) => {
          const sectionMap: { [key: string]: string } = {
            "Política de Seguridad": "securityPolicy",
            "Política de Calidad": "qualityPolicy",
            "Compromiso de servicio": "serviceCompromise",
            Links: "links",
          };
          return (
            <Button
              key={item.text}
              variant="containedWhite"
              className="min-w-[4rem] px-[3rem] py-[1.5rem]"
              onClick={() => {
                const sectionKey = sectionMap[item.text];
                if (sectionKey) handleScrollToSection(sectionKey);
              }}
            >
              <Typography fontFamily={"Montserrat"} fontWeight={500}>
                {item.text}
              </Typography>
            </Button>
          );
        })}
      </Box>
      <Box
        sx={{
          width: "calc(100vw - 4rem)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          justifySelf: "center",
          marginTop: { lg: "-4rem" },
          flexDirection: {
            xs: "column",
            md: "row",
          },
          height: "fit-content",
          color: "#1F6B45",
        }}
      >
        <Grid
          container
          spacing={3}
          sx={{ display: "flex", flexWrap: "wrap-reverse" }}
        >
          <Grid sx={{ maxWidth: "100%" }} item sm={12} md={6} lg={8}>
            <img
              src={TeamMembers}
              style={{
                borderRadius: "14px",
                width: "100%",
              }}
              alt="Team Members"
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4}>
            <Box
              sx={{
                width: "100%",
                maxWidth: "36rem",
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-start" },
                justifyContent: "flex-end",
                height: "100%",
                textAlign: { xs: "center", md: "left" },
                px: { xs: 2, sm: 0 },
                mx: "auto",
              }}
            >
              <Typography
                variant="h2"
                fontFamily="Montserrat"
                sx={{
                  fontSize: {
                    xs: "1.8rem",
                    sm: "2.2rem",
                    md: "2.8rem",
                    lg: "3.2rem",
                  },
                  fontWeight: 700,
                  mb: { xs: 2, md: 3 },
                  alignSelf: { xs: "center", md: "flex-start" },
                }}
              >
                Quienes Somos
              </Typography>
              <Typography
                fontFamily="Montserrat"
                sx={{
                  fontSize: {
                    xs: "0.9rem",
                    sm: "1rem",
                    md: "1.05rem",
                  },
                  fontWeight: 500,
                  lineHeight: 1.6,
                  maxWidth: "100%",
                }}
              >
                Somos una empresa especializada en desaduanamiento de mercadería
                y logística desde 1963. Brindamos servicios profesionales en
                operaciones aduaneras y portuarias, como importación,
                exportación, tránsito y zonas francas. Mantenemos a nuestros
                clientes informados y protegemos la integridad de su
                documentación.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box ref={sectionRefs.securityPolicy}>
        <SecurityPolicy />
      </Box>
      <Box
        ref={sectionRefs.qualityPolicy}
        sx={{
          width: "calc(100vw - 4rem)",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          justifySelf: "center",
          marginBottom: "2rem",
        }}
      >
        <Grid container>
          <Grid item xs={12} lg={7} xl={6}>
            <Box
              sx={{
                backgroundColor: "#4E8468",
                display: "flex",
                justifySelf: { xs: "center", lg: "end" },
                flexWrap: "wrap",
                maxWidth: "50rem",
                padding: {
                  xs: "1rem 1.5rem",
                  md: "2.5rem",
                },
                borderRadius: "30px",
                borderTop: {
                  md: "3.3rem solid white",
                },
                height: { xs: "fit-content", xl: "100%" },
                gap: "2rem",
                margin: {
                  xs: "1.5rem 0 0 0",
                  md: "-3.3rem 0 0 0",
                  lg: "-3.3rem 2rem 2rem 2rem",
                  xl: "-3.3rem 2rem auto 2rem",
                },
              }}
            >
              <Box sx={{ width: { xs: "100%", lg: "auto" } }}>
                <Typography
                  variant="h2"
                  sx={{
                    color: colors.white,
                    fontSize: {
                      xs: "2.5rem",
                      sm: "3rem",
                      md: "3.7rem",
                    },
                    fontWeight: 700,
                    maxWidth: { xs: "auto", lg: "30rem" },
                  }}
                  fontFamily={"Montserrat"}
                >
                  Políticas de calidad
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "1rem",
                    flexDirection: {
                      xs: "column",
                      md: "row",
                    },
                    alignItems: {
                      xs: "left",
                    },
                    gap: "1rem",
                  }}
                >
                  <Typography
                    sx={{
                      color: colors.white,
                      fontSize: "0.8rem",
                      alignSelf: { xs: "flex-start", md: "flex-end" },
                      fontWeight: 400,
                      lineHeight: "1.25rem",
                      maxWidth: "25rem",
                    }}
                    fontFamily={"Montserrat"}
                  >
                    Buscamos brindar a nuestros clientes un servicio de calidad,
                    oportuno y adaptado a sus necesidades. Nos esforzamos por
                    mejorar continuamente para asegurar su satisfacción.
                    Contamos con un equipo profesional y responsable que utiliza
                    procesos automatizados y toma decisiones informadas. Nos
                    enfocamos en crecer constantemente, optimizando procesos,
                    aplicando tecnología y capacitando a nuestro personal.
                    Mantenemos actualizados en las normativas de comercio
                    exterior para ofrecer un servicio confiable y cumplir con
                    las regulaciones legales.
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "center",
                  width: { xs: "100%", md: "auto" },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "white",
                    padding: "5px",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    minWidth: "8rem",
                    maxWidth: "30rem",
                  }}
                >
                  <img src={unit} alt="unit" />
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item sm={12} lg={5} xl={6}>
            <Box
              sx={{
                borderRadius: "35px",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                height: { xs: "auto", lg: "30rem" },
                width: "100%",
              }}
            >
              <Box
                component="img"
                src={Office}
                sx={{
                  marginTop: "1rem",
                  width: { xs: "100%", lg: "42rem", xl: "47.5rem" },
                  height: { xs: "auto", lg: "26rem" },
                  borderRadius: "20px",
                  display: "flex",
                  justifySelf: "center",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          width: { xs: "calc(100vw - 4rem)", lg: "90vw" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          justifySelf: "center",
          flexDirection: "row",
          height: "fit-content",
          color: "#1F6B45",
        }}
      >
        <Grid
          container
          spacing={4}
          sx={{ display: "flex", flexWrap: "wrap-reverse" }}
        >
          <Grid item xs={12} lg={5}>
            <Box
              sx={{
                borderRadius: "25px",
                flexDirection: "column",
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
              }}
            >
              <img
                src={Office2}
                className="w-full"
                style={{
                  height: "100%",
                  borderRadius: "20px",
                }}
                alt="Office 2"
              />
            </Box>
          </Grid>
          <Grid
            ref={sectionRefs.serviceCompromise}
            item
            xs={12}
            lg={7}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <Box
              ref={sectionRefs.serviceCompromise}
              sx={{
                borderRadius: "30px",
                maxHeight: "100%",
                alignSelf: "flex-end",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-end",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <Typography
                variant="h2"
                fontFamily={"Montserrat"}
                sx={{
                  color: "#1F6B45",
                  fontSize: {
                    xs: "1.8rem",
                    sm: "1.8rem",
                    md: "3rem",
                    lg: "3.2rem",
                    xl: "3.3rem",
                  },
                  fontWeight: 700,
                  margin: 0,
                  textAlign: {
                    xs: "center",
                    sm: "center",
                    md: "left",
                  },
                  maxWidth: "25rem",
                  alignSelf: {
                    xs: "center",
                    md: "flex-start",
                  },
                }}
              >
                Compromiso de servicio
              </Typography>
              <Typography
                fontFamily={"Montserrat"}
                sx={{
                  marginTop: "0.5rem",
                  color: "#1F6B45",
                  lineHeight: 1.5,
                  fontSize: {
                    xs: "1.1rem",
                    lg: "1rem",
                    xl: "1.1rem",
                  },
                  whiteSpace: "pre-line",
                  width: "100%",
                }}
              >
                {`Murillo Ruffinelli Moreira SRL es una empresa especializada en operaciones de importación, exportación y tránsito en el ámbito del Comercio Exterior. También ofrecemos asesoramiento integral en temas de Comercio Internacional, Tratados Internacionales y Normas de Origen. \n
                Como empresa familiar dirigida por la familia Moreira, heredamos de nuestro padre Hugo Moreira, uno de los fundadores, el compromiso con la profesión, la dedicación al trabajo y el respeto hacia nuestros clientes. Tratamos todos los negocios como importantes, sin importar su categoría, y buscamos la excelencia para satisfacer sus necesidades.\n
                En línea con nuestra Política de Calidad y nuestro Sistema de Gestión de Calidad basado en la Norma UNIT-ISO 9001:2008, queremos informar a nuestros clientes sobre las condiciones que rigen nuestros servicios en MRM.`}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <TermsOfUse />
      <Box ref={sectionRefs.links}>
        <LandingLogos />
      </Box>
      <Footer />
    </Box>
  );
};

export default LandingPage;
